<script setup lang="ts">
import type { VNodeRef } from 'vue';

import { onMounted, onUnmounted, ref } from 'vue';

import ItemsSideBar from '@/components/bars/ItemsSideBar.vue';
import MainSideBar from '@/components/bars/MainSideBar.vue';
import SmartAppBar from '@/components/bars/SmartAppBar.vue';
import SmartHelpcenterSideBar from '@/components/bars/SmartHelpcenterSideBar.vue';
import { useSidebarsStore } from '@/stores/useSidebarsStore';
import {
  quoteSubList,
  quoteTitle,
  reportsSubList,
  reportsTitle,
  smsSubList,
  smsTitle,
} from '@/constants/menuLists';

export interface Props {
  absolute?: boolean;
}
const props = withDefaults(defineProps<Props>(), {});

const sidebarsStore = useSidebarsStore();

const root = ref<VNodeRef | null>(null);

onMounted(() => {
  sidebarsStore.setRootElement(root.value);
});

onUnmounted(() => {
  sidebarsStore.setRootElement(null);
});
</script>

<template>
  <div ref="root" :class="$style.smartListBars">
    <MainSideBar
      v-model="sidebarsStore.sidebars.main"
      :absolute="props.absolute"
      :class="$style.mainSideBar"
    />
    <SmartAppBar :absolute="props.absolute" :class="$style.appBar" />
    <ItemsSideBar
      v-model="sidebarsStore.sidebars.quote"
      :absolute="props.absolute"
      :class="$style.itemsSideBar"
      :sub-list="quoteSubList"
      :title="quoteTitle"
      data-drawer="quote"
    />
    <ItemsSideBar
      v-model="sidebarsStore.sidebars.reports"
      :absolute="props.absolute"
      :class="$style.itemsSideBar"
      :sub-list="reportsSubList"
      :title="reportsTitle"
      data-drawer="reports"
    />
    <ItemsSideBar
      v-model="sidebarsStore.sidebars.sms"
      :absolute="props.absolute"
      :class="$style.itemsSideBar"
      :sub-list="smsSubList"
      :title="smsTitle"
      data-drawer="sms"
    />
    <SmartHelpcenterSideBar
      v-model="sidebarsStore.sidebars.helpcenter"
      :absolute="props.absolute"
      :class="$style.helpSideBar"
      data-drawer="help"
    />
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smartListBars {
}
  .mainSideBar {
  }
  .appBar {
  }
  .itemsSideBar {
  }
  .helpSideBar {
  }

@media print {
  .smartListBars {
  }
    .mainSideBar {
      display: none;
    }
    .appBar {
    }
    .itemsSideBar {
      display: none;
    }
    .helpSideBar {
      display: none;
    }
}
</style>
